module.exports = __webpack_public_path__ + "img/jean_jaures.34794b1d.jpg";